module.exports = __webpack_public_path__ + "img/aboutUs.ce4c1a19.png";